import React, { Component } from 'react';
import { connect } from 'react-redux';
import 'blobjs'
import 'canvas-toBlob'
import { saveAs } from 'file-saver';

class DownLoad extends Component {

    constructor(props) {
        super(props);
    }
    onDlButtonClick(e) {
        e.preventDefault()
        this.props.canvas.toBlob(blob => saveAs(blob, 'coloriage-sur-quadrillage.png'))
    }
    render() {
        return (
            <button
                className="btn btn-primary"
                onClick={this.onDlButtonClick.bind(this)}
                title="Télécharger l'image">
                <span className="glyphicon glyphicon-download-alt"></span>
            </button>
        )
    }
}

const mapStateToProps = ({ canvas }) => {
  return { canvas };
}

export default connect(mapStateToProps)(DownLoad)
